/* istanbul ignore file */

export enum BulkSiteUploadShapefileActivateSitesStep {
    MaxEnterpriseSites = 0,
    AssociateChargeNumber = 1,
    ActivateSites = 2,
}
